import { useAuth } from '@/lib/sdk/auth/hooks';
import { helpers } from '@/client/utils/helpers';

/**
 * Whether the user can build with the AI assistant: the org has the ai_chat feature and
 * the user holds workflows:ai_assist (super admins always can), as the server checks.
 */
export function useCanBuildWithAI(): boolean {
  const { user, currentOrg, featurePermissions, userPermission } = useAuth();
  const isSuperAdmin = user?.is_super_admin ?? false;
  if (isSuperAdmin) return true;
  return (
    helpers.hasFeatureAccess(currentOrg?.feature_access, 'ai_chat') &&
    helpers.hasFeatureAction(featurePermissions, userPermission, isSuperAdmin, 'workflows', 'ai_assist')
  );
}
